export default "__VITE_ASSET__npny5cJ7__"